import gsap from "gsap";

import ScrollTrigger from "gsap/dist/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

document.querySelectorAll(".js-hero").forEach((el) => {
	const logo = el.querySelector(".js-logo"),
		bg = el.querySelector(".js-hero-bg"),
		img = el.querySelector(".js-image-load"),
		logo_svg = el.querySelector(".js-logo_svg"),
		title = el.querySelector(".js-title"),
		text = el.querySelector(".js-text"),
		button_area = el.querySelector(".js-button-area");

	ScrollTrigger.create({
		trigger: el,
		start: "top top",
		scrub: true,
		end: "bottom top",
		animation: gsap.to(bg, { y: "6.25rem" }),
	});

	gsap.to(logo, {
		opacity: 0,
		scrollTrigger: {
			trigger: el,
			// start: "center-=25% top",
			start: "top top",
			scrub: true,
			end: "+=50%",
		},
	});

	// initial animation

	const animateImageIn = () => {
		gsap.fromTo(
			img,
			{ scale: 1.05 },
			{
				scale: 1,
				duration: 1.2,
				delay: 0.3,
			},
		);

		gsap.fromTo(
			img,
			{ opacity: 0 },
			{
				opacity: 1,
				duration: 0.7,
				delay: 0.3,
			},
		);
	};

	if (img.complete && img.naturalHeight !== 0) {
		animateImageIn();
	} else {
		img.addEventListener("load", () => {
			animateImageIn();
		});
	}

	gsap.fromTo(
		[logo_svg, title, text, button_area],
		{
			opacity: 0,
			y: "0.625rem",
		},
		{
			opacity: 1,
			y: 0,
			delay: 0.3,
			stagger: 0.1,
		},
	);
});
